export const pt = {
    title: `Reenviar e-mail de confirmação`,
    description: `Sua conta não está confirmada.`,
    lastSentAt: `Último e-mail de confirmação enviado em {date}`,
    wait: `Aguarde {minutes} minutos antes de reenviar.`,
    resendButton: `Reenviar e-mail`,
    emailResent: `E-mail de confirmação foi reenviado`,
    success: `E-mail de confirmação enviado.`,
    failure: `Falha ao reenviar e-mail de confirmação.`,
    progress: `Reenviando o e-mail de confirmação...`,
};
//# sourceMappingURL=pt.js.map